module.exports = __webpack_public_path__ + "a08c57af8820b631673f38bd36acc4ca.jpg";